import { CandidateDetails } from 'Modules/Core/Admin/CandidateProfile/CandidateDetails';
import { CandidateTraitsTable } from 'Modules/Core/Admin/CandidateProfile/CandidateTraits';
import { MainContainer } from 'Modules/Core/Admin/EmployerProfile/EmployerDetails.styled';
// import { Products } from 'Modules/Core/Admin/EmployerProfile/Products';
// import { Subscriptions } from "Modules/Core/Admin/EmployerProfile/Subscriptions";
import { Notification } from "Modules/Core/Notification";
import { useParams } from 'react-router-dom';
export const CandidateDetailsWrapper = () => {
    const { candidateId } = useParams();
    return (<>
        <MainContainer>
            <CandidateDetails candidateId={candidateId} />
            <CandidateTraitsTable candidateId={candidateId} />
            {/* <EmployerAccounts employerId={employerId} />
            <Products employerId={employerId} />
            <Credits employerId={employerId} />
            <DisableEmployer /> */}
        </MainContainer>
        <Notification />
    </>);
}